const INTERRUPT_ERROR_NAME = 'InterruptError';

/** 抛出一个中断错误 */
export const throwInterruptError = (message: string) => {
  const error = new Error(message);
  error.name = INTERRUPT_ERROR_NAME;
  throw error;
};

/** 判断是否是中断错误 */
export const isInterruptError = (error: Error) => error.name === INTERRUPT_ERROR_NAME;
